'use client';

import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { usePathname } from 'next/navigation';
import { getPageVariant } from '@/lib/animations/pageTransitions';

interface PageTransitionProps {
  children: React.ReactNode;
}

/**
 * PageTransition component wraps page content with animation
 * Respects user's motion preferences (prefers-reduced-motion)
 * Only animates content area, not layout components
 */
export default function PageTransition({ children }: PageTransitionProps) {
  const pathname = usePathname();
  const shouldReduceMotion = useReducedMotion();
  const variants = getPageVariant(pathname);

  // If user prefers reduced motion, skip animations
  if (shouldReduceMotion) {
    return <>{children}</>;
  }

  return (
    <motion.div data-component-id="src/components/common/PageTransition.tsx:28:4" data-component-path="src/components/common/PageTransition.tsx" data-component-line="28" data-component-end-line="40" data-component-file="PageTransition.tsx" data-component-name="motion.div" data-component-content="%7B%22elementName%22%3A%22motion.div%22%7D"
      key={pathname}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={variants}
      style={{
        width: '100%',
        minHeight: '100vh',
      }}
    >
      {children}
    </motion.div>
  );
}
